import React from "react";
import Image from "next/legacy/image";
import Link from "next/link";

const SimpleNavbar = (props) => {
  return (
    <section className="ts-drawer__section | dir-down">
      <header className="ts-header">
        <nav
          className="ts-header__nav"
          style={{
            maxWidth: "72rem",
            margin: "auto",
            padding: "1.5rem 3rem",
          }}
        >
          <Link href="/" className="flex self-center no-hover">
            <Image
              src={
                props.is_dark
                  ? "/teamshares-logo-white-sm.svg"
                  : "/teamshares-logo-color-sm.svg"
              }
              width="112px"
              height="16px"
              className="-mt-1"
              alt="Teamshares Logo"
            />
          </Link>
        </nav>
      </header>
    </section>
  );
};

export default SimpleNavbar;
